import { render, staticRenderFns } from "./deletePage.vue?vue&type=template&id=5c3f365f&lang=pug&"
import script from "./deletePage.vue?vue&type=script&lang=js&"
export * from "./deletePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports